import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, unref as _unref, resolveComponent as _resolveComponent } from "vue"

const _hoisted_1 = { class: "cmi00310-wrapper" }
const _hoisted_2 = { class: "cmi00310-form-area cmi00310-form" }
const _hoisted_3 = { class: "cmi00310-input-area q-gutter-y-sm" }
const _hoisted_4 = {
  key: 0,
  class: "col"
}
const _hoisted_5 = {
  key: 0,
  class: "col",
  style: {"word-break":"break-all"}
}
const _hoisted_6 = {
  key: 0,
  class: "col",
  style: {"word-break":"break-all"}
}
const _hoisted_7 = {
  key: 0,
  class: "col",
  style: {"word-break":"break-all"}
}
const _hoisted_8 = {
  key: 0,
  class: "col",
  style: {"word-break":"break-all"}
}
const _hoisted_9 = {
  key: 0,
  class: "col"
}
const _hoisted_10 = {
  key: 0,
  class: "row q-mb-none q-ma-none"
}
const _hoisted_11 = {
  key: 0,
  class: "q-gutter-sm"
}
const _hoisted_12 = {
  key: 0,
  class: "col"
}
const _hoisted_13 = { class: "q-ma-none" }
const _hoisted_14 = {
  key: 0,
  class: "q-gutter-sm"
}
const _hoisted_15 = {
  key: 0,
  class: "col"
}
const _hoisted_16 = { class: "q-ma-none" }
const _hoisted_17 = { key: 0 }
const _hoisted_18 = { key: 1 }

import { reactive, ref } from 'vue';
import { useRouter } from 'vue-router';
import Loading from 'quasar/src/plugins/Loading.js';;
import axios from 'axios';
import AlertDialog from '../../components/dialogs/AlertDialog.vue';
import MemberDetailCard from '../../components/card/MemberDetailCard.vue';
import FormFooterBanner from '../../components/banner/FormFooterBanner.vue';
import PageHeaderBanner from '../../components/banner/PageHeaderBanner.vue';
import CustomerSelects from '../../components/selects/CustomerSelects.vue';
import ResultStatusCode from '../../common/code/ResultStatusCode';
import HttpResponseStatusCode from '../../common/code/HttpResponseStatusCode';
import MessageChip from '../../components/chip/MessageChip.vue';
import { isEmpty, isValidateEmail } from '../../common/utils/validateUtils';
import DetailResultStatusCode from '../../common/code/DetailResultStatusCode';
import messages from '../../messages/message.json';

interface Props {
  userId: string;
}

export default /*@__PURE__*/_defineComponent({
  __name: 'CMI00310',
  props: {
    userId: {}
  },
  setup(__props: any) {

const router = useRouter();

const props = __props;
// 会員情報
const mKaiinInfo = ref({
  approval_stat: '',
  auth_level: '',
  user_id: '',
  user_name_mei: '',
  user_name_sei: '',
  customer_cd: '',
  mail_address: '',
  phone_number: '',
  work_school_name: '',
  affiliation_department_name: '',
  postal_cd: '',
  todohuken_name: '',
  street_address: '',
  quote_request_mail1: '',
  quote_request_mail2: '',
  quote_request_mail3: '',
  quote_request_mail4: '',
  update_timestamp: '',
  user_attribute: '',
});

// 入力値
const inputData = reactive({
  customer_cd: '',
  quote_request_mail1: '',
  quote_request_mail2: '',
  quote_request_mail3: '',
  quote_request_mail4: '',
  approval_stat: '',
  default_approval_stat: '',
  user_order_flg: '',
});
const input = ref(true);

// 更新確認ダイアログ
const isConfirmationFlag = ref(false);

// 更新完了ダイアログ
const regist = ref(false);

// 変更内容確認画面表示切り替え
const confirmation = () => {
  input.value = false;
};
// 確認画面から入力画面に戻る
const prev = () => {
  input.value = true;
};

// エラーメッセージ
const errMessage = ref('');

// エラーメッセージチップフラグ
const isMessageChip = ref(false);

// 入力内容エラーフラグ
const errorFlag = ref(false);

/**
 * エラーチップを初期化
 */
const resetError = async () => {
  errMessage.value = '';
  isMessageChip.value = false;
};

/**
 * 会員情報取得
 */
const getMemberInfo = async () => {
  // Loading Start
  Loading.show();

  const user_id = props.userId;
  const formData = new FormData();
  formData.append('user_id', user_id);
  // 会員情報取得
  await axios
    .post('/cmi003101/memberInfo', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          mKaiinInfo.value = res.data.mkaiin;

          inputData.customer_cd = res.data.mkaiin.customer_cd;
          inputData.quote_request_mail1 = res.data.mkaiin.quote_request_mail1;
          inputData.quote_request_mail2 = res.data.mkaiin.quote_request_mail2;
          inputData.quote_request_mail3 = res.data.mkaiin.quote_request_mail3;
          inputData.quote_request_mail4 = res.data.mkaiin.quote_request_mail4;
          inputData.approval_stat = res.data.mkaiin.approval_stat;
          inputData.default_approval_stat = res.data.mkaiin.approval_stat;
          inputData.user_order_flg = res.data.mkaiin.order_flg;

          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          router.push({ name: 'error' });

          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};

/**
 *  会員情報の更新
 */
const updateMemberInfo = async () => {
  // Loading Start
  Loading.show();

  errMessage.value = '';
  isMessageChip.value = false;

  // 変更データ作成
  const formData = new FormData();
  formData.append('customer_cd', inputData.customer_cd === null ? '' : inputData.customer_cd);
  formData.append(
    'quote_request_mail1',
    inputData.quote_request_mail1 === null ? '' : inputData.quote_request_mail1
  );
  formData.append(
    'quote_request_mail2',
    inputData.quote_request_mail2 === null ? '' : inputData.quote_request_mail2
  );
  formData.append(
    'quote_request_mail3',
    inputData.quote_request_mail3 === null ? '' : inputData.quote_request_mail3
  );
  formData.append(
    'quote_request_mail4',
    inputData.quote_request_mail4 === null ? '' : inputData.quote_request_mail4
  );
  formData.append('user_order_flg', inputData.user_order_flg);
  formData.append('approval_stat', inputData.approval_stat);
  formData.append('default_approval_stat', inputData.default_approval_stat);
  formData.append('user_id', props.userId);
  formData.append('mail_address', mKaiinInfo.value.mail_address);
  await axios
    .post('/cmi003101/member/approve', formData)
    .then((res) => {
      const { common } = res.data;
      switch (common.status) {
        // 正常終了の場合
        case ResultStatusCode.SUCCESS:
          // ダイアログの表示
          regist.value = true;
          break;
        // エラーの場合
        case ResultStatusCode.ERROR:
          switch (common.detail_status) {
            case DetailResultStatusCode.UPDATE_ERROR:
              // エラーメッセージ表示
              errMessage.value = common.message;
              isMessageChip.value = true;
              break;

            // システムエラーの場合
            case DetailResultStatusCode.SYSTEM_ERROR:
              router.push({ name: 'error' });
              break;
            default:
              router.push({ name: 'error' });
          }
          break;
        default:
          router.push({ name: 'error' });
      }
    })
    .catch((err) => {
      if (err.res.status === HttpResponseStatusCode.SESSIONTIMEOUT) {
        // セッションタイムアウトの場合
        router.push({ name: 'login', query: { timeout: 'timeout' } });
      } else {
        // その他エラーの場合
        router.push({ name: 'error' });
      }
    })
    .finally(() => {
      // Loading End
      Loading.hide();
    });
};
/**
 * 変更内容確認（入力チェック）
 *
 */
const checkInputForm = async () => {
  // エラーフラグのリセット
  errMessage.value = '';
  isMessageChip.value = false;
  errorFlag.value = false;
  // 見積依頼メールアドレス重複チェック
  if (
    inputData.quote_request_mail3 !== null &&
    inputData.quote_request_mail3 !== '' &&
    inputData.quote_request_mail3 === inputData.quote_request_mail4
  ) {
    errMessage.value = messages.ja.message.MSG_50072E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 見積依頼メールアドレス重複チェック
  if (
    inputData.quote_request_mail2 !== null &&
    inputData.quote_request_mail2 !== '' &&
    (inputData.quote_request_mail2 === inputData.quote_request_mail3 ||
      inputData.quote_request_mail2 === inputData.quote_request_mail4)
  ) {
    errMessage.value = messages.ja.message.MSG_50072E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 見積依頼メールアドレス重複チェック
  if (
    inputData.quote_request_mail1 !== null &&
    inputData.quote_request_mail1 !== '' &&
    (inputData.quote_request_mail1 === inputData.quote_request_mail2 ||
      inputData.quote_request_mail1 === inputData.quote_request_mail3 ||
      inputData.quote_request_mail1 === inputData.quote_request_mail4)
  ) {
    errMessage.value = messages.ja.message.MSG_50072E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 画面．入力_見積依頼メールアドレス３が未入力 且つ 画面．入力_見積依頼メールアドレス４が入力済みの場合エラー
  if (
    (inputData.quote_request_mail3 === null || inputData.quote_request_mail3 === '') &&
    inputData.quote_request_mail4 !== null &&
    inputData.quote_request_mail4 !== ''
  ) {
    errMessage.value = messages.ja.message.MSG_50059E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 画面．入力_見積依頼メールアドレス２が未入力 且つ 画面．入力_見積依頼メールアドレス３か３４が入力済みの場合エラー
  if (
    (inputData.quote_request_mail2 === null || inputData.quote_request_mail2 === '') &&
    ((inputData.quote_request_mail3 !== null && inputData.quote_request_mail3 !== '') ||
      (inputData.quote_request_mail4 !== null && inputData.quote_request_mail4 !== ''))
  ) {
    errMessage.value = messages.ja.message.MSG_50059E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  // 画面．入力_見積依頼メールアドレス２が未入力 且つ 画面．入力_見積依頼メールアドレス３か３４が入力済みの場合エラー
  if (
    (inputData.quote_request_mail1 === null || inputData.quote_request_mail1 === '') &&
    ((inputData.quote_request_mail2 !== null && inputData.quote_request_mail2 !== '') ||
      (inputData.quote_request_mail3 !== null && inputData.quote_request_mail3 !== '') ||
      (inputData.quote_request_mail4 !== null && inputData.quote_request_mail4 !== ''))
  ) {
    errMessage.value = messages.ja.message.MSG_50059E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }

  // 画面．入力_承認ステータス＝承認済み 且つ 画面．入力_見積依頼メールアドレス１が未入力の場合エラー
  if (
    inputData.approval_stat === '1' &&
    (inputData.quote_request_mail1 === null || inputData.quote_request_mail1 === '')
  ) {
    errMessage.value = messages.ja.message.MSG_50074E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }

  // 画面．入力_承認ステータス＝承認済み 且つ 画面．得意先コードが未入力の場合エラー
  if (
    inputData.approval_stat === '1' &&
    (inputData.customer_cd === '' || inputData.customer_cd === null)
  ) {
    errMessage.value = messages.ja.message.MSG_50075E;
    isMessageChip.value = true;
    errorFlag.value = true;
  }
  window.scrollTo({ top: 0 });
  if (!errorFlag.value) {
    // 変更内容確認表示
    confirmation();
  }
};

// 会員一覧への遷移
const returnMembers = async () => {
  router.replace({ name: 'members' });
};
/**
 * 初期表示処理
 */
// propsが存在しない場合
if (!props.userId) {
  // 前画面に遷移
  returnMembers();
} else {
  getMemberInfo();
}

return (_ctx: any,_cache: any) => {
  const _component_q_input = _resolveComponent("q-input")!
  const _component_q_radio = _resolveComponent("q-radio")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_form = _resolveComponent("q-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(PageHeaderBanner, null, {
      title: _withCtx(() => _cache[22] || (_cache[22] = [
        _createTextVNode("承認設定")
      ])),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(MessageChip, {
        display: isMessageChip.value,
        level: "E",
        message: errMessage.value
      }, null, 8, ["display", "message"]),
      _createVNode(MemberDetailCard, {
        data: mKaiinInfo.value,
        mode: "memberapproval"
      }, null, 8, ["data"]),
      _createVNode(_component_q_form, {
        autofocus: "",
        greedy: "",
        novalidate: "",
        onSubmit: _cache[21] || (_cache[21] = ($event: any) => (checkInputForm())),
        onValidationError: resetError
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", {
              class: _normalizeClass(["row q-gutter-x-md", [!input.value && 'display']])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass([input.value ? 'col' : 'col-3 text-right q-mr-md'] + ' code')
              }, [
                _createElementVNode("label", {
                  class: _normalizeClass(inputData.approval_stat === '1' && input.value ? 'requier' : '')
                }, "得意先コード", 2),
                (input.value)
                  ? (_openBlock(), _createBlock(CustomerSelects, {
                      key: 0,
                      customer: inputData.customer_cd === null ? '' : inputData.customer_cd,
                      "lazy-rules": "",
                      onSelected: _cache[0] || (_cache[0] = ($event: any) => (inputData.customer_cd = $event)),
                      onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, null, 8, ["customer"]))
                  : _createCommentVNode("", true)
              ], 2),
              (!input.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                    _createElementVNode("span", null, _toDisplayString(inputData.customer_cd), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["row q-gutter-x-md", [!input.value && 'display']])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('email ' + [input.value ? 'col q-pt-md' : 'col-3 text-right q-mr-md'])
              }, [
                _createElementVNode("label", {
                  class: _normalizeClass(inputData.approval_stat === '1' && input.value ? 'requier' : '')
                }, "見積依頼メ－ルアドレス1", 2),
                (input.value)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 0,
                      modelValue: inputData.quote_request_mail1,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((inputData.quote_request_mail1) = $event)),
                      outlined: "",
                      dense: "",
                      maxlength: "254",
                      class: "input-area left-input",
                      rules: [
                  (val) => !_unref(isEmpty)(val) || _unref(isValidateEmail)(val) || _ctx.$t('validation.email'),
                ],
                      "lazy-rules": "",
                      onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue", "rules"]))
                  : _createCommentVNode("", true)
              ], 2),
              (!input.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    _createElementVNode("span", null, _toDisplayString(inputData.quote_request_mail1), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["row q-gutter-x-md", [!input.value && 'display']])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('email ' + [input.value ? 'col' : 'col-3 text-right q-mr-md'])
              }, [
                _cache[23] || (_cache[23] = _createElementVNode("label", null, "見積依頼メ－ルアドレス2", -1)),
                (input.value)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 0,
                      modelValue: inputData.quote_request_mail2,
                      "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((inputData.quote_request_mail2) = $event)),
                      outlined: "",
                      dense: "",
                      maxlength: "254",
                      class: "input-area left-input",
                      rules: [(val) => !_unref(isEmpty)(val) || _unref(isValidateEmail)(val) || _ctx.$t('validation.email')],
                      "lazy-rules": "",
                      onKeydown: _cache[5] || (_cache[5] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue", "rules"]))
                  : _createCommentVNode("", true)
              ], 2),
              (!input.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    _createElementVNode("span", null, _toDisplayString(inputData.quote_request_mail2), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["row q-gutter-x-md", [!input.value && 'display']])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('email ' + [input.value ? 'col' : 'col-3 text-right q-mr-md'])
              }, [
                _cache[24] || (_cache[24] = _createElementVNode("label", null, "見積依頼メ－ルアドレス3", -1)),
                (input.value)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 0,
                      modelValue: inputData.quote_request_mail3,
                      "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((inputData.quote_request_mail3) = $event)),
                      outlined: "",
                      dense: "",
                      maxlength: "254",
                      class: "input-area left-input",
                      rules: [(val) => !_unref(isEmpty)(val) || _unref(isValidateEmail)(val) || _ctx.$t('validation.email')],
                      "lazy-rules": "",
                      onKeydown: _cache[7] || (_cache[7] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue", "rules"]))
                  : _createCommentVNode("", true)
              ], 2),
              (!input.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("span", null, _toDisplayString(inputData.quote_request_mail3), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["row q-gutter-x-md", [!input.value && 'display']])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('email ' + [input.value ? 'col' : 'col-3 text-right q-mr-md'])
              }, [
                _cache[25] || (_cache[25] = _createElementVNode("label", null, "見積依頼メ－ルアドレス4", -1)),
                (input.value)
                  ? (_openBlock(), _createBlock(_component_q_input, {
                      key: 0,
                      modelValue: inputData.quote_request_mail4,
                      "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((inputData.quote_request_mail4) = $event)),
                      outlined: "",
                      dense: "",
                      maxlength: "254",
                      class: "input-area left-input",
                      rules: [(val) => !_unref(isEmpty)(val) || _unref(isValidateEmail)(val) || _ctx.$t('validation.email')],
                      "lazy-rules": "",
                      onKeydown: _cache[9] || (_cache[9] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["enter"]))
                    }, null, 8, ["modelValue", "rules"]))
                  : _createCommentVNode("", true)
              ], 2),
              (!input.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                    _createElementVNode("span", null, _toDisplayString(inputData.quote_request_mail4), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["row q-gutter-x-md", [!input.value && 'display']])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('approve-setting ' + [input.value ? 'col q-pb-md' : 'col-3 text-right q-mr-md'])
              }, _cache[26] || (_cache[26] = [
                _createElementVNode("label", null, "ユーザー権限", -1)
              ]), 2),
              (!input.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, _cache[27] || (_cache[27] = [
                    _createElementVNode("span", null, "一般ユーザー", -1)
                  ])))
                : _createCommentVNode("", true)
            ], 2),
            (input.value)
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _cache[28] || (_cache[28] = [
                  _createElementVNode("span", null, "一般ユーザー", -1)
                ])))
              : _createCommentVNode("", true),
            _createElementVNode("div", {
              class: _normalizeClass(["row q-gutter-x-md", [!input.value && 'display']])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('approve-setting ' + [input.value ? 'col q-pt-md' : 'col-3 text-right q-mr-md'])
              }, [
                _cache[29] || (_cache[29] = _createElementVNode("label", null, "会員登録承認", -1)),
                (input.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                      _createVNode(_component_q_radio, {
                        modelValue: inputData.approval_stat,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((inputData.approval_stat) = $event)),
                        val: "1",
                        label: "承認する"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_q_radio, {
                        modelValue: inputData.approval_stat,
                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((inputData.approval_stat) = $event)),
                        val: "0",
                        label: "承認しない"
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              (!input.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                    _createElementVNode("span", _hoisted_13, _toDisplayString(inputData.approval_stat === '0' ? '承認しない' : '承認する'), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: _normalizeClass(["row q-gutter-x-md", [!input.value && 'display']])
            }, [
              _createElementVNode("div", {
                class: _normalizeClass('approve-setting ' + [input.value ? 'col q-pt-md' : 'col-3 text-right q-mr-md'])
              }, [
                _cache[30] || (_cache[30] = _createElementVNode("label", null, "注文可・不可設定", -1)),
                (input.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_q_radio, {
                        modelValue: inputData.user_order_flg,
                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((inputData.user_order_flg) = $event)),
                        val: "0",
                        label: "注文可"
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_q_radio, {
                        modelValue: inputData.user_order_flg,
                        "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((inputData.user_order_flg) = $event)),
                        val: "1",
                        label: "注文不可"
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true)
              ], 2),
              (!input.value)
                ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                    _createElementVNode("span", _hoisted_16, _toDisplayString(inputData.user_order_flg === '1' ? '注文不可' : '注文可'), 1)
                  ]))
                : _createCommentVNode("", true)
            ], 2),
            _createVNode(FormFooterBanner, { style: {"position":"inherit"} }, {
              "button-area": _withCtx(() => [
                (input.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _createVNode(_component_q_btn, {
                        outline: "",
                        class: "q-mr-xs",
                        style: {"color":"var(--q-delete)","width":"120px"},
                        label: "戻る",
                        onClick: _cache[14] || (_cache[14] = ($event: any) => (_unref(router).replace({ name: 'members' })))
                      }),
                      _createVNode(_component_q_btn, {
                        modelValue: input.value,
                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((input).value = $event)),
                        color: "primary",
                        type: "chenge",
                        style: {"width":"120px"},
                        label: "内容確認"
                      }, null, 8, ["modelValue"])
                    ]))
                  : _createCommentVNode("", true),
                (!input.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_q_btn, {
                        modelValue: input.value,
                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((input).value = $event)),
                        color: "primary",
                        outline: "",
                        class: "q-mr-xs",
                        style: {"width":"120px"},
                        icon: "mdi-chevron-left",
                        label: "前へ",
                        onClick: prev
                      }, null, 8, ["modelValue"]),
                      _createVNode(_component_q_btn, {
                        color: "primary",
                        style: {"width":"120px"},
                        label: "設定",
                        onClick: _cache[17] || (_cache[17] = ($event: any) => (isConfirmationFlag.value = true))
                      })
                    ]))
                  : _createCommentVNode("", true)
              ]),
              _: 1
            }),
            _createVNode(AlertDialog, {
              display: isConfirmationFlag.value,
              level: "information",
              title: "更新確認",
              text: ['入力された内容で更新します。', 'よろしいですか？'],
              onConfirm: _cache[18] || (_cache[18] = ($event: any) => ((isConfirmationFlag.value = false), updateMemberInfo())),
              onClose: _cache[19] || (_cache[19] = ($event: any) => (isConfirmationFlag.value = false))
            }, null, 8, ["display"]),
            _createVNode(AlertDialog, {
              display: regist.value,
              level: "information",
              confirmation: "",
              title: "承認設定完了",
              text: ['会員情報の変更が完了しました。'],
              onComplete: _cache[20] || (_cache[20] = ($event: any) => ((regist.value = false), returnMembers()))
            }, null, 8, ["display"])
          ])
        ]),
        _: 1
      })
    ])
  ]))
}
}

})